/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.1.4
* 
*******************************************************************************/
import core from"../base/core";let events={BUFFERING:"event:buffering",CONNECTING:"event:connecting",ERROR:"event:error",FINISHED:"event:finished",FORCE_PLAY:"event:force-play",PAUSE:"event:pause",SUBTITLE_UPDATE:"event:subtitle-update",TIME_UPDATE:"event:time-update"},bufferings={FINISH:"buffering:finish",PROGRESS:"buffering:progress",START:"buffering:start"},EVENT=events,BUFFERING=bufferings;export default{DEFAULT_PARENT_NODE:core.isBrowser()&&document.body,EVENT:EVENT,BUFFERING:BUFFERING};